import { useTranslation } from "react-i18next";
import {
  getHistoricalGoldCertifications,
  getHistoricalCredentials,
  getHistoricalCoreCertifications,
} from "../data/Training.history";
import {
  ComplexListItem,
  ListAdvanced,
  useFlags,
  ContentSectionAccordion,
} from "@inductiveautomation/ws-components";
import {
  CertificationActionCallback,
  Certification,
  ElectiveWithType,
  CertificationType,
} from "../Training.types";
import { getHistoryStyles } from "../_training.styles";
import { TranslateKey } from "../../../i18n/i18n.types";
import { AccountFlags } from "../../../featureFlags.ts";

const HEADING_TRANSLATE_KEY: Record<CertificationType, TranslateKey> = {
  CREDENTIAL: "training.credential.history.title",
  CORE: "training.core.history.title",
  GOLD: "training.gold.history.title",
  // TODO: update the translation json to include history or rework altogether
  ELECTIVE: "training.elective.title",
  EMPLOYEE: "training.employee.title",
};

const HistorySection = ({
  onAction,
  certification,
}: {
  onAction: CertificationActionCallback;
  certification: Exclude<Certification, ElectiveWithType> | undefined;
}) => {
  const { t } = useTranslation();
  const { classes } = getHistoryStyles();
  const { tsAccountCertificateDownloadFe, tsAccountTrainingBadgeDownloadFe } =
    useFlags<AccountFlags>();
  const type = certification?.type;
  const retrieveHistory = () => {
    if (type === "CREDENTIAL") {
      return getHistoricalCredentials(t, certification, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      });
    } else if (type === "CORE") {
      return getHistoricalCoreCertifications(t, certification, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      });
    } else {
      return getHistoricalGoldCertifications(t, certification, onAction, {
        tsAccountCertificateDownloadFe,
        tsAccountTrainingBadgeDownloadFe,
      });
    }
  };
  const history = retrieveHistory();
  return history.length ? (
    <div className={classes.accordionContainer}>
      <ContentSectionAccordion
        overline={type ? t(HEADING_TRANSLATE_KEY[type]) : ""}
        resourceId={`${type}-content-section-accordion`}
        fullWidth
        open
      >
        <ListAdvanced
          showShadow={false}
          lists={[
            {
              variant: "spacious",
              items: history,
              itemComponent: ComplexListItem,
              onSelection: () => undefined,
              fullHeight: true,
            },
          ]}
        />
      </ContentSectionAccordion>
    </div>
  ) : null;
};

export default HistorySection;
